import useApi from 'common/hooks/useApi';
import { isActionCompleteSuccess } from 'common/services/api/isActionCompleteSuccess';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import React, { useReducer, useState } from 'react';
import { useHistory } from 'react-router-dom';
import validate from './create-account-valid';
import CreateAccountPresenter from './CreateAccountPresenter';
import reducer, { init } from './CreateAccountReducer';
import ReactGA from 'react-ga4';

function CreateAccountContainer() {
  const [state, dispatch] = useReducer(reducer, init());
  const [attempts, setAttempts] = useState(0);
  const { push } = useHistory();
  const [{ loading, error }, request] = useApi<ActionCompleteResponse>({
    url: '/register/newProfile',
    method: 'POST',
    bypassTokenCheck: true,
  });

  const handleChange = (key: string, value: string) => {
    dispatch({ type: 'setState', payload: { [key]: value } });
  };

  const handleQuestionChange = (num: '1' | '2' | '3') => (value: string) => {
    dispatch({
      type: 'updateSecurityQuestion',
      payload: { question: value, num },
    });
  };

  const handleAnswerChange = (num: '1' | '2' | '3') => (value: string) => {
    dispatch({ type: 'updateSecurityAnswer', payload: { answer: value, num } });
  };

  const handleSubmit = async () => {
    setAttempts((prev) => prev + 1);
    if (validate(state).length === 0) {
      const { data } = await request({
        firstName: state.first,
        lastName: state.last,
        suffix: state.suffix,
        email: state.email,
        passWord: state.password,
        questions: [
          {
            id: Number(state.security['1'].question),
            answer: state.security['1'].answer,
          },
          {
            id: Number(state.security['2'].question),
            answer: state.security['2'].answer,
          },
          {
            id: Number(state.security['3'].question),
            answer: state.security['3'].answer,
          },
        ],
      });
      if (data && isActionCompleteSuccess(data)) {
        ReactGA.event({
          category: 'Authentication',
          action: 'Profile Created',
        });
        push('/auth/send-confirmation', { email: state.email });
      }
    }
  };

  return (
    <CreateAccountPresenter
      data={state}
      onChange={handleChange}
      onQuestionChange={handleQuestionChange}
      onAnswerChange={handleAnswerChange}
      onSubmit={handleSubmit}
      feedback={attempts > 0 ? validate(state) : []}
      loading={loading}
      error={error}
    />
  );
}

export default CreateAccountContainer;
